import { useEffect, useRef, useState } from "react";

function StickyTopBox({ children }) {
  const divRef = useRef();
  const [divClass, setDivClass] = useState("p-0 bg-transparent");

  const listenScrollEvent = () => {
    window.scrollY === divRef.current.offsetTop
      ? setDivClass("p-2 bg-light shadow")
      : setDivClass("p-0 bg-transparent");
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  return (
    <div className={"sticky-top mb-4 " + divClass} ref={divRef}>
      {children}
    </div>
  );
}

export default StickyTopBox;
